import script from "./standart-audio-player-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./standart-audio-player-list.vue?vue&type=script&setup=true&lang=ts"

import "./standart-audio-player-list.vue?vue&type=style&index=0&id=a2c09db2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2c09db2"]])

export default __exports__